"use client";

import { useState } from "react";

export default function ScrollSecret() {
    const [isVisible, setIsVisible] = useState(false);

    // Optional: Only render if scrolled near bottom to save resources, 
    // but for "fixed reveal" it needs to be there. 
    // We can just render it always.

    return (
        <div className="fixed bottom-0 left-0 w-full h-[300px] z-0 flex items-end justify-center pb-8 pointer-events-none bg-black">
            <div className="text-center">
                <div className="text-6xl mb-4 animate-bounce">🙈</div>
                <h3 className="text-xl font-bold font-mono uppercase tracking-widest text-gray-400">
                    Nothing to see here
                </h3>
                <p className="text-xs text-gray-300 font-mono mt-2">
                    (You're persistent though. We like that.)
                </p>
                <div className="mt-4 font-mono text-[10px] text-gray-200 opacity-50">
                    console.log("Curiosity rewarded.");
                </div>
            </div>
        </div>
    );
}
